/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/iframe-has-title */
import { IonButtons, IonContent, IonFooter, IonHeader, IonMenuButton, IonPage, IonRow, IonSlide, IonSlides, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import './Page.css';

const BB17: React.FC = () => {
    const name = "Binarual Bass Synthesizer";
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>{name}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonSlides>
                    <IonSlide>
                        <IonRow style={{ height: "1080px" }}>
                            <video width='100%' controls src='https://songadays.s3-us-west-2.amazonaws.com/songs/iOS/eb6d5d6e57a2020-04-12T05:14:02.820ZRPReplay_Final1586668387.MP4#t=17' />
                        </IonRow>
                    </IonSlide>
                </IonSlides>
                <IonFooter style={{ bottom: 0, position: "fixed" }}>
                    <a href="https://apps.apple.com/us/app/bb17-auv3-synthesizer/id1484562949?ls=1">
                        <img src="https://tools-qr-production.s3.amazonaws.com/output/apple-toolbox/5e04e206967efba20d8bc83703d42563/13dc17fe-0166-455b-9d1c-4536d608c0b4.png" />
                    </a>
                </IonFooter>
            </IonContent>
        </IonPage >
    );
};

export default BB17;
